import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getOrderClaimForm, setOrderClaimForm } from 'domains/order/Order.store';
import { getTextMandatory, isHidden } from 'pages/MyOrdersPage/OrderClaims/claimForm.utils';
import { makeKey, RULES_DATA } from 'pages/MyOrdersPage/OrderClaims/claimFormRulesData';
import { FlexRow } from 'pages/MyOrdersPage/OrderClaims/OrderClaims.styled';
import { Flex, Select, Text } from 'UI';

const SymptomSection = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const claimForm = useSelector(getOrderClaimForm);
  const rulesData =
    RULES_DATA[makeKey({ formType: claimForm.formType, reason: claimForm.reason, option: claimForm.option })];

  if (isHidden(rulesData?.symptom)) {
    return null;
  }

  const symptomOptions = [
    { value: '1', title: t('order.claim.symptom.option.1', '1-Clicking noise') },
    { value: '2', title: t('order.claim.symptom.option.2', '2-Fails to charge') },
    { value: '3', title: t('order.claim.symptom.option.3', '3-Lack of power') },
    { value: '4', title: t('order.claim.symptom.option.4', '4-Leakage') },
    { value: '5', title: t('order.claim.symptom.option.5', '5-Significant play') },
    { value: '6', title: t('order.claim.symptom.option.6', '6-Stuck') },
    { value: '7', title: t('order.claim.symptom.option.7', '7-Loud noise') },
    { value: '8', title: t('order.claim.symptom.option.8', '8-Seized') },
    { value: '9', title: t('order.claim.symptom.option.9', '9-Warped') },
    { value: '10', title: t('order.claim.symptom.option.10', '10-Other (please specify in your message)') },
  ];

  return (
    <FlexRow gap={30}>
      <Flex direction={'column'} maxWidth={300}>
        <Text type="base" noWrap>
          {getTextMandatory(t('order.claim.symptom', 'Symptom'), rulesData?.symptom)}
        </Text>
        <Select
          bordered
          options={symptomOptions}
          value={claimForm.symptom}
          onChange={(symptom: string) => dispatch(setOrderClaimForm({ ...claimForm, symptom }))}
          placeholder={t('common.action.select', 'Select')}
        />
      </Flex>
    </FlexRow>
  );
};

export default SymptomSection;
